import Command from '@ckeditor/ckeditor5-core/src/command';

import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
  htmlAttributes: { ID },
} = CkeditorConstants;

export default class UnwrapLinkCommand extends Command {
  execute(ids) {    
    this._unwrapLinks(ids);
  }

  _unwrapLinks(ids) {
    const editor = this.editor;
    const domElement = editor.editing.view.domRoots.get("main");    
    editor.model.change((writer) => {
      _.forEach(ids, (id) => {
        const elementToRemove = domElement.querySelector(`[${ID}='${id}']`);      
        if (elementToRemove) {
          const linkViewElement = editor.editing.view.domConverter.mapDomToView(elementToRemove);
          const elementSelected = editor.editing.mapper.toModelElement(linkViewElement);
          elementSelected && writer.unwrap(elementSelected);
        }
      });
    });
  }
}